import React from "react";
import { Box, Link, Typography } from "@mui/material";
import { Link as RouterLink, useParams } from "react-router-dom";
import { useScreenshotTranslation } from "../../../../lib/screenshotI18n";
import ScreenshotExpiredPage from "../../components/ScreenshotExpiredPage";
import { isScreenshotSceneExpired } from "../../lib/screenshotAccess";
import { SCREENSHOTS_MAIN_PATH } from "../../routes";
import { phoneShellSx, slidingScreenshotAccent } from "../../styles/screenshotStyles";
import { getAnimationScene } from "../animationScene";
import AnimationPlayPage from "./AnimationPlayPage";

export default function AnimationScenePage() {
    const { slug } = useParams();
    const { t } = useScreenshotTranslation();
    const scene = getAnimationScene(slug);

    if (isScreenshotSceneExpired(slug)) {
        return <ScreenshotExpiredPage />;
    }

    if (!scene) {
        return (
            <Box sx={{ ...phoneShellSx, p: 2 }}>
                <Typography color="error" sx={{ mb: 1 }}>
                    {t("mobileScreenshot.common.unknown-animation", { slug })}
                </Typography>
                <Link component={RouterLink} to={SCREENSHOTS_MAIN_PATH} sx={{ color: slidingScreenshotAccent }}>
                    {t("mobileScreenshot.common.back-to-index")}
                </Link>
            </Box>
        );
    }

    return <AnimationPlayPage scene={scene} />;
}
